import { enableProdMode } from '@angular/core'

import { bootstrapApplication } from '@angular/platform-browser'
import { init, setContext } from '@sentry/angular'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { parseVersion } from './app/modules/core/types/manager-version'
import { environment } from './environments/environment'

if (environment.production) {
  enableProdMode()
}

if (environment.sentryDSN) {
  init({
    dsn: environment.sentryDSN,
    ignoreErrors: ['Non-Error promise rejection captured'],
  })
}
const version = parseVersion(environment.version)
setContext('Build Details', {
  Commit: version.commit,
  Date: version.time.toISOString(),
})

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [...appConfig.providers],
}).catch((err) => console.error(err))
